import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
@Component({
  selector: 'app-rede-credenciada-pdf',
  templateUrl: './rede-credenciada-pdf.component.html',
  styleUrls: ['./rede-credenciada-pdf.component.css']
})
export class RedeCredenciadaPdfComponent {
  @ViewChild('contentPrint', { static: false }) el!: ElementRef;

  @Input() listaRedeCredenciada: any;
  @Input() formulario: any;

  listaCredenciados: any = [];
  listaDescredenciados: any = [];
  listaNovosCredenciados: any = [];
  listaReferenciados: any = [];
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit() {
    this.listaCredenciados = this.listaRedeCredenciada.credenciados;
    this.listaDescredenciados = this.listaRedeCredenciada.descredenciados;
    this.listaNovosCredenciados = this.listaRedeCredenciada.novosCredenciados;
    this.listaReferenciados = this.listaRedeCredenciada.referenciados;

     setTimeout(() => {
        const pdf = new jsPDF('p', 'pt', 'letter');

        const captureElementAsImage = (elementId: string): Promise<string> => {
          const element = document.getElementById(elementId);
          if (element) {
            return html2canvas(element).then(canvas => canvas.toDataURL('image/png', 0.8));
          }
          return Promise.resolve('');
        };

        Promise.all([
          captureElementAsImage('header'),        
        ]).then(([headerImage]) => {     
          pdf.addImage(headerImage, 'PNG', 10, 10, 300, 5);
        });
        pdf.getFontList();

        const elementoHtml = this.el.nativeElement;
        elementoHtml.style.letterSpacing = '0.45px';
        elementoHtml.style.fontFamily = 'Arial';

        pdf.html(elementoHtml, {
          margin: [20, 10, 10, 10],
          callback: (pdf: any) => {
            pdf.setLineWidth(pdf.internal.pageSize.getWidth())
    
            pdf.save('Rede Credenciada.pdf');
            this.activeModal.close(true);
          }
        })
     }, 1);

//     setTimeout(() => {
//       const pdf = new jsPDF('p', 'pt', 'letter');
//       const mainElement = document.getElementById('content');
        
//       const captureElementAsImage = (elementId: string): Promise<string> => {
//           const element = document.getElementById(elementId);
//           if (element) {
//               return html2canvas(element, { scale: 2 }).then(canvas => canvas.toDataURL('image/png', 0.8));
//           }
//           return Promise.resolve('');
//       };
  
//       Promise.all([
//           captureElementAsImage('header'),
//           captureElementAsImage('main'),
//           captureElementAsImage('footer')
//       ]).then(([headerImage, mainImage, footerImage]) => {
          
//           pdf.addImage(headerImage, 'PNG', 10, 10, 190, 30);
  
//           if (mainElement) {
//               html2canvas(mainElement).then(canvas => {
//                   const imgData = canvas.toDataURL('image/png');
//                   const imgWidth = 190;
//                   const pageHeight = pdf.internal.pageSize.height;
//                   const imgHeight = (canvas.height * imgWidth) / canvas.width;
//                   let yPosition = 50; 

//                   while (yPosition + imgHeight > pageHeight - 40) { 
//                       pdf.addImage(imgData, 'PNG', 10, yPosition, imgWidth, pageHeight - yPosition - 40);
//                       pdf.addPage();
//                       yPosition = 40; 
//                   }
  
//                   pdf.addImage(imgData, 'PNG', 10, yPosition, imgWidth, imgHeight);

//                   if (footerImage) {
//                       pdf.addImage(footerImage, 'PNG', 10, pageHeight - 40, 190, 30);
//                   }
  
//                   pdf.save('Rede Credenciada.pdf');
//                   this.activeModal.close(true);
//               });
//           }
//       });
//   }, 1);

  }
}
